export const TECHNOLOGIES = [
  'Python',
  'GitHub Actions',
  'Azure Pipelines',
  'Kubernetes',
  'HashiCorp Vault',
  'Docker',
  'DataDog',
  'Azure Functions',
  'CosmosDB',
  'Azure Service Bus',
  'Bash',
  'Git',
];
